import { makeAutoObservable, runInAction } from "mobx";
import i18n from "i18next";
import dayjs, { Dayjs } from "dayjs";
import MainStore from "MainStore";
import { validate, validateField } from "./valid";
import { getIncomingDocument } from "api/IncomingDocument";
import { createIncomingDocument } from "api/IncomingDocument";
import { updateIncomingDocument } from "api/IncomingDocument";

// dictionaries
import { getDocumentTypes } from "api/DocumentType";

import storeList from "../IncomingDocumentListView/store"


class NewStore {
  id = 0
  approval_request_id = 0
  document_type_id = 0
  name = ""
  file_name = ""
  file_path = ""
  file_size = 0
  mime_type = ""
  file_hash = ""
  bga_document_number = ""
  bga_document_date: Dayjs | null = null
  received_from = 0
  received_at: Dayjs | null = null

  errors: { [key: string]: string } = {};

  // Справочники
  document_types = []


  constructor() {
    makeAutoObservable(this);
  }

  clearStore() {
    runInAction(() => {
      this.id = 0
      this.approval_request_id = 0
      this.document_type_id = 0
      this.name = ""
      this.file_name = ""
      this.file_path = ""
      this.file_size = 0
      this.mime_type = ""
      this.file_hash = ""
      this.bga_document_number = ""
      this.bga_document_date = null
      this.received_from = 0
      this.received_at = null

      this.errors = {}
    });
  }

  handleChange(event) {
    const { name, value } = event.target;
    (this as any)[name] = value;
    this.validateField(name, value);
  }

  async validateField(name: string, value: any) {
    const { isValid, error } = await validateField(name, value);
    if (isValid) {
      this.errors[name] = "";
    } else {
      this.errors[name] = error;
    }
  }

  async onSaveClick(onSaved: (id: number) => void) {
    var data = {
      id: this.id - 0,
      approval_request_id: storeList.idMain,
      document_type_id: this.document_type_id - 0,
      name: this.name,
      file_name: this.file_name,
      file_path: this.file_path,
      file_size: this.file_size - 0,
      mime_type: this.mime_type,
      file_hash: this.file_hash,
      bga_document_number: this.bga_document_number,
      bga_document_date: this.bga_document_date ? dayjs(this.bga_document_date).toISOString() : null,
      received_from: this.received_from - 0,
      received_at: this.received_at ? dayjs(this.received_at).toISOString() : null,
    };

    const { isValid, errors } = await validate(data);
    if (!isValid) {
      this.errors = errors;
      MainStore.openErrorDialog(i18n.t("message:error.alertMessageAlert"));
      return;
    }

    try {
      MainStore.changeLoader(true);
      let response;
      if (this.id === 0) {
        response = await createIncomingDocument(data);
      } else {
        response = await updateIncomingDocument(data);
      }
      if (response.status === 201 || response.status === 200) {
        onSaved(response);
        if (data.id === 0) {
          MainStore.setSnackbar(i18n.t("message:snackbar.successSave"), "success");
        } else {
          MainStore.setSnackbar(i18n.t("message:snackbar.successEdit"), "success");
        }
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

  async doLoad(id: number) {
    // загрузка справочников
    await this.loadDocumentTypes();
    this.id = id;

    if (id === null || id === 0) {
      return;
    }

    this.loadIncomingDocument(id);
  }

  loadDocumentTypes = async () => {
    try {
      MainStore.changeLoader(true);
      const response = await getDocumentTypes();
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        runInAction(() => {
          this.document_types = response.data
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  }

  loadIncomingDocument = async (id: number) => {
    try {
      MainStore.changeLoader(true);
      const response = await getIncomingDocument(id);
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        runInAction(() => {
          this.id = response.data.id;
          this.approval_request_id = response.data.approval_request_id;
          this.document_type_id = response.data.document_type_id;
          this.name = response.data.name;
          this.file_name = response.data.file_name;
          this.file_path = response.data.file_path;
          this.file_size = response.data.file_size;
          this.mime_type = response.data.mime_type;
          this.file_hash = response.data.file_hash;
          this.bga_document_number = response.data.bga_document_number;
          this.bga_document_date = response.data.bga_document_date ? dayjs(response.data.bga_document_date) : null;
          this.received_from = response.data.received_from;
          this.received_at = response.data.received_at ? dayjs(response.data.received_at) : null;
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };
}

export default new NewStore();